type DynamicCTA = {
  init: () => void;
};

const DynamicCTA: DynamicCTA = {
  init() {
    const dynamicCTAWidgets = document.querySelectorAll('[data-hook=dynamicCTAWidget]');
    if (!dynamicCTAWidgets.length) return;

    dynamicCTAWidgets?.forEach((widget) => {
      const dynamicCTAWidget = widget as HTMLElement;

      const videoButton = dynamicCTAWidget.querySelector(
        '[data-hook=dynamicCTAWidget__videoButton]',
      ) as HTMLButtonElement;
      if (!videoButton) return;

      const options = dynamicCTAWidget.dataset.options
        ? JSON.parse(dynamicCTAWidget.dataset.options)
        : '';
      const videoButtonTextWrapper = videoButton.querySelector('span');

      videoButton.addEventListener('click', () => {
        const relatedVideo = videoButton.nextElementSibling as HTMLVideoElement;
        if (!(relatedVideo instanceof HTMLVideoElement)) return;

        if (relatedVideo.paused) {
          relatedVideo.play();
          videoButton.classList.remove('is-paused');
          if (options.videoButtonText.play && videoButtonTextWrapper) {
            videoButtonTextWrapper.innerText = options.videoButtonText.pause;
          }
        } else {
          relatedVideo.pause();
          videoButton.classList.add('is-paused');
          if (options.videoButtonText.pause && videoButtonTextWrapper) {
            videoButtonTextWrapper.innerText = options.videoButtonText.play;
          }
        }
      });
    });
  },
};

export default DynamicCTA;
